import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { EyeIcon, PencilIcon } from '@heroicons/react/24/outline'
import { EllipsisVerticalIcon } from '@heroicons/react/24/solid'
import { IndicesRecord } from '@opensearch-project/opensearch/api/_types/cat.indices'

import { Badge, ButtonApp } from '@/components'
import { getBadgeVariantByStatus } from '@/utils'

type ColumnProps = { data: IndicesRecord }

export const columnsIndexes = (
  onViewDetails: (_: IndicesRecord) => void,
  onEditMapping: (_: IndicesRecord) => void,
) => {
  const menuItems = [
    {
      label: 'View Details',
      icon: <EyeIcon className="w-4" />,
      primary: true,
      command: onViewDetails,
    },
    {
      label: 'Edit Mapping',
      icon: <PencilIcon className="w-4" />,
      primary: false,
      command: onEditMapping,
    },
  ]

  return [
    { field: 'uuid', headerName: 'ID', width: 300, minWidth: 300 },
    { field: 'index', headerName: 'Name', width: 350, minWidth: 350 },
    { field: 'entityName', headerName: 'Entity Name', width: 300, minWidth: 300 },
    {
      field: 'store.size',
      headerName: 'Store Size',
      width: 200,
      minWidth: 200,
      cellRenderer: (props: ColumnProps) => (
        <Badge className="w-fit text-sm">{props.data['store.size'] ?? '0'}</Badge>
      ),
    },
    {
      field: 'docs.count',
      headerName: 'Docs Count',
      width: 200,
      minWidth: 200,
      cellRenderer: (props: ColumnProps) => (
        <Badge className="w-fit text-sm">{props.data['docs.count'] ?? '0'}</Badge>
      ),
    },
    {
      field: 'status',
      headerName: 'Status/Health',
      pinned: 'right',
      width: 200,
      minWidth: 200,
      cellRenderer: (props: ColumnProps) => {
        const badgeVariant = getBadgeVariantByStatus(props.data.status)

        return (
          <div className="flex items-center h-full gap-2">
            <Badge className="w-fit text-sm" {...badgeVariant} title="Status">
              {props.data.status ?? 'unspecified'}
            </Badge>
            <Badge className="w-fit text-sm" {...badgeVariant} title="Health">
              {props.data.health ?? 'unspecified'}
            </Badge>
          </div>
        )
      },
    },
    {
      headerName: 'Actions',
      width: 120,
      minWidth: 120,
      pinned: 'right',
      cellRenderer: (props: ColumnProps) => {
        return (
          <div className="flex items-center h-full">
            <Menu>
              <MenuButton>
                <EllipsisVerticalIcon width={22} className="text-gray-600" />
              </MenuButton>
              <MenuItems anchor="bottom end" className="bg-white p-2 shadow-xl flex flex-col gap-2">
                {menuItems.map(({ icon, label, primary, command }) => (
                  <MenuItem>
                    <ButtonApp
                      className="px-4 py-1.5 gap-2"
                      isPrimary={primary}
                      handleClick={() => command(props.data)}
                    >
                      {icon}
                      <span className="text-sm">{label}</span>
                    </ButtonApp>
                  </MenuItem>
                ))}
              </MenuItems>
            </Menu>
          </div>
        )
      },
    },
  ]
}
